<template>
  <div class="main-presets-container">
    <div class="presets-title">{{ $t('multiTaskPresets.presets') }}</div>
    <div class="buttons-line">
      <el-tooltip class="item" effect="light" :content="$t('multiTaskPresets.saveAs')" placement="bottom-start">
        <span>
          <el-button @click="createClick" class="el-icon-plus"></el-button>
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="light" :content="$t('multiTaskPresets.edit')" placement="bottom-start">
        <span>
          <el-button @click="editClick" class="el-icon-edit" :disabled="buttonDisabled"></el-button>
        </span>
      </el-tooltip>
      <el-tooltip class="item" effect="light" :content="$t('multiTaskPresets.delete')" placement="bottom-start">
        <span>
          <el-button @click="deleteClick" class="el-icon-delete" :disabled="buttonDisabled"></el-button>
        </span>
      </el-tooltip>
    </div>
    <!-- <div class="selected-preset-name" v-if="selectedPreset">{{selectedPreset.name}}</div> -->
    <div class="presets-list">
      <div
        v-for="(preset, index) in presetsArray"
        :key="index"
        class="preset-item"
        :class="preset.class"
      >
        <div class="preset-line">
          <i
            :class="preset.visible?'el-icon-caret-bottom':'el-icon-caret-right'"
            class="arrow-icon"
            @click="presetNameClicked(preset)"
          ></i>
          <div
            class="preset-name"
            :class="{'selected':(selectedPreset &&  selectedPreset.name===preset.name)}"
            @click="presetSelected(preset)"
            @dblclick="presetNameClicked(preset)"
          >{{preset.name}}</div>
        </div>
        <div v-if="preset.visible">
          <li v-for="(id, index) in preset.idArray" :key="index" class="preset-id">{{id[2]}}</li>
        </div>
      </div>
    </div>
    <div v-if="selectedPreset" class="buttons-line">
    : "",
      <el-button @click="applyPreset">{{ $t('multiTaskPresets.apply') }}</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      buttonDisabled: true,
      selectedPreset: null,
      //[{id: 1, text: 'PROM'}, {id: 3, text: 'BYT'}]
      presetsArray: [],
    };
  },
  methods: {
    createClick() {
      this.$prompt(this.$t('multiTaskPresets.enterPresetName'), {
        confirmButtonText: "OK",
        cancelButtonText: this.$t('multiTaskPresets.cancellation'),
      })
        .then(({ value }) => {
          // console.log(this);
          let sameName;
          // console.log(this.presetsArray);
          if (!!this.presetsArray) {
            sameName = this.presetsArray.find((pr) => pr.name === value.trim());
          } else {
            this.$store.commit("setError", this.$t('multiTaskPresets.dataForPresetNotSelected'));
            return;
          }
          if (sameName) {
            this.$store.commit(
              "setError",
              this.$t('multiTaskPresets.presetWithThisNameAlredyExist')
            );
            return;
          }
          this.$store.commit("setCheckedArray");
          let preset = {
            name: value.trim(),
            idArray: this.checkedArray,
            visible: false,
          };
          this.presetsArray.push(preset);
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    editClick() {
      this.$confirm(this.$t('multiTaskPresets.selectedNewElements'), {
        confirmButtonText: "OK",
        cancelButtonText: this.$t('multiTaskPresets.cancellation'),
        type: "warning",
      })
        .then(() => {
          this.$store.commit("setCheckedArray");
          this.selectedPreset.idArray = this.checkedArray;
        })
        .catch(() => {});
    },
    deleteClick() {
      this.$confirm(this.$t('multiTaskPresets.deleteSelectedPreset'), {
        confirmButtonText: "OK",
        cancelButtonText: this.$t('multiTaskPresets.cancellation'),
        type: "warning",
      })
        .then(() => {
          let index = this.presetsArray.findIndex(
            (el) => el.name === this.selectedPreset.name
          );
          // console.log(index);
          this.presetsArray.splice(index, 1);
          this.selectedPreset = null;
          this.buttonDisabled = true;
        })
        .catch(() => {});
    },
    presetSelected(preset) {
      this.selectedPreset = preset;
      this.buttonDisabled = false;
    },
    presetNameClicked(preset) {
      preset.visible = !preset.visible;
    },
    applyPreset() {
      this.$store.commit("applyPreset", this.selectedPreset.idArray);
    },
  },
  created() {
    if (!!JSON.parse(this.$localStorage.get("wa-presets")))
      this.presetsArray = JSON.parse(this.$localStorage.get("wa-presets"));
  },
  computed: {
    ...mapGetters(["checkedArray"]),
  },
  watch: {
    presetsArray() {
      this.$localStorage.set("wa-presets", JSON.stringify(this.presetsArray));
    },
  },
};
</script>

<style scoped>
.main-presets-container {
  margin: 0px 20px;
  width: 20vw;
}
.presets-title {
  font-weight: 600;
  font-size: 1.2em;
  text-align: center;
}
.buttons-line {
  transform: scale(0.8);
  display: flex;
}
.buttons-line .el-tooltip:not(:first-of-type) {
  margin-left: 10px;
}
.selected {
  color: var(--active-color);
}
.selected-preset-name {
  margin-bottom: 20px;
  font-weight: 600;
  font-size: 1.1em;
}
.preset-item {
  margin-bottom: 10px;
  user-select: none;
}
.preset-line {
  cursor: pointer;
  display: flex;
}
.arrow-icon {
  transform: scale(1.2);
  margin-top: 3px;
}
.arrow-icon:hover{
  color: var(--active-color);
}
.preset-name {
  font-weight: 500;
}
.preset-id {
  list-style-type: circle;
  margin-left: 10px;
  cursor: default;
}
</style>